import { lazyRoute } from "../config/config-utils"
import { ACTION_ON_TRANSLATION_CLICK } from "./constants"

const GutenbergApp = lazyRoute(()=> import("./GutenbergApp"), "GutenbergApp")

export const GUTENBERG_ROUTES_CONFIG = {
  additionalProps: {
    clickOnWordTriggerSpeak: true,
    firstActionOnTranslationClick: ACTION_ON_TRANSLATION_CLICK.enum.bookmark,
    language: "de",
  },
  browserTitle: "Idiot - Dostoyevsky(German)",
  component: GutenbergApp,
  key: "gutenberg",
  label: "Idiot - Dostoyevsky(German)",
  route: "/gutenberg",
}
export const GUTENBERG_FRENCH_ROUTES_CONFIG = {
  additionalProps: {
    clickOnWordTriggerSpeak: true,
    firstActionOnTranslationClick: ACTION_ON_TRANSLATION_CLICK.enum.speak,
    language: "fr",
    secondActionOnTranslationClick: ACTION_ON_TRANSLATION_CLICK.enum.bookmark,
  },
  browserTitle: "Besove - Dostoyevsky(French)",
  component: GutenbergApp,
  key: "gutenberg-french",
  label: "Besove - Dostoyevsky(French)",
  route: "/gutenberg-french",
}
